// 生成コードの実行中のエラーは、失敗として終わらせる
export const failOnRunError =
  (setSuccess: (success: boolean) => void, setGameOver: (gameOver: boolean) => void) =>
  (error: unknown) => {
    console.error(error);
    setSuccess(false);
    setGameOver(true);
  };
